import { multiaddr } from '@multiformats/multiaddr';

import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const reconnectPeerThunk = createAppAsyncThunk<
  { sixId: string; peerId: string; success: true },
  { sixId: string; peerId: string }
>(
  'connection/reconnectPeer',
  async({ sixId, peerId }, { getState, extra: { pocServices }, rejectWithValue }) => {
    try {
      const libp2pNode = pocServices.p2pStackManagerService.getLibp2pNode(sixId);
      if (libp2pNode === null) {
        throw new Error(`No LibP2P node found for six '${sixId}'`);
      }

      const six = getState().sixCatalog.sixes.find((candidate) => candidate.id === sixId);
      if (six == null) {
        throw new Error(`No six found with id '${sixId}'`);
      }

      if (six.bootstrapNodes.length === 0) {
        throw new Error(`No bootstrap nodes configured for six '${sixId}'`);
      }

      let lastError: Error | null = null;
      for (const relayAddress of six.bootstrapNodes) {
        try {
          await libp2pNode.dial(multiaddr(`${relayAddress}/p2p-circuit/p2p/${peerId}`));
          return { sixId, peerId, success: true as const };
        } catch (error) {
          lastError = error instanceof Error ? error : new Error(String(error));
        }
      }

      throw lastError ?? new Error('All relay connection attempts failed');
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return rejectWithValue({ message });
    }
  }
);
